module.exports = __webpack_public_path__ + "static/media/入门礼包@2x.cfd4dd7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_149/img/入门礼包@2x.png
// module id = 1434
// module chunks = 0